import Vue from "vue";

export default {
    async find(id) {
        const partners = Vue.api.partners.find(id);
        return partners;
    },

    // async load({ pagination, filters }) {
    //     const establishments = await Vue.api.establishments.loadUser({
    //         pagination,
    //         filters,
    //     });

    //     store.commit("ESTABLISHMENTS_SET_LIST", establishments);

    //     return establishments;
    // },

};
